// src/hooks/useAutoOrder.js
import axios from "axios";
import Swal from "sweetalert2";

import useDarkModeClass from "./useDarkModeClass";
import createThemedSwal from "../utils/sweetAlertWithTheme";

/**
 * Custom hook for handling auto order functionality
 * @param {Function} onSuccess - Optional callback function called after successful order send
 * @returns {Function} handleAutoOrder - Function to trigger auto order
 */
const useAutoOrder = (onSuccess) => {
  const isDarkMode = useDarkModeClass();
  const themedSwal = createThemedSwal(isDarkMode);

  const handleAutoOrder = async (id) => {
    themedSwal
      .fire({
        title: "Do you want to send the order?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Send",
        denyButtonText: `Don't send`,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          try {
            const { data } = await axios.post("/alibaba/api/v1/crossOrder/", {
              wege_order_id: id,
            });
            themedSwal.fire({
              icon: data?.failed_orders ? "error" : "success",
              title: data?.failed_orders ? "Oops..." : "success",
              text: data?.failed_orders
                ? data.failed_orders[0]?.message
                : data.message,
            });
            if (onSuccess && !data?.failed_orders) {
              onSuccess();
            }
          } catch (err) {
            themedSwal.fire({
              icon: "error",
              title: "Oops...",
              text: err?.response?.data?.message || err.message,
            });
          }
        } else if (result.isDenied) {
          Swal.fire("Order did not send", "", "info");
        }
      });
  };

  return handleAutoOrder;
};

export default useAutoOrder;

